/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 document.addEventListener('variant:changed', function(event) {
   var variant = event.detail.variant; // Gives you access to the whole variant details
   var freeshippingthreshold = document.getElementById("threshold_in_cents").value;
   var elgfreeshipping = document.getElementById("elgfreeshipping");
   if(variant.price < freeshippingthreshold){
     elgfreeshipping.setAttribute("style", "display:none");
   }else{
     elgfreeshipping.setAttribute("style", "display:block");
   }
 });

//OBX tabs for homepage
function SwitchTab(tab_id, tab_content) {
	// get all tab content blocks
	var x = document.getElementsByClassName("tabcontent");
	var i;
	for (i = 0; i < x.length; i++) {
		x[i].style.display = 'none'; // hide all tab content
	}
	document.getElementById(tab_content).style.display = 'block'; // display the content of the tab we need
 
	// get all tab menu items by class names
	var x = document.getElementsByClassName("tabmenu");
	var i;
	for (i = 0; i < x.length; i++) {
		x[i].className = 'tabmenu'; 
	}
	document.getElementById(tab_id).className = 'tabmenu active';
}

if (sessionStorage.getItem('AnnouncementOnce') !== 'true') {
function shippingPopup() {
  var el = document.getElementById('free-shipping');
  el.style.display = 'block';
  
  var overlay = document.getElementById('overlay');
  overlay.style.display = 'block';
  
  var close = document.getElementById('close-shipping');
  close.addEventListener('click', function(e){
  	el.style.display = 'none';
    overlay.style.display = 'none';
    
  }, false)
}

var timer = setTimeout(function () { shippingPopup(); clearTimeout(timer) }, 5000);
  
  sessionStorage.setItem('AnnouncementOnce','true');
}